// import React, { useState } from "react";
// import { TextField, MenuItem, Box, FormHelperText } from "@mui/material";

// const SimpleDatePicker = ({ value, onChange, required }) => {
//     const [selectedDate, setSelectedDate] = useState(() => {
//         if (value instanceof Date) {
//             return {
//                 day: value.getDate(),
//                 month: value.getMonth() + 1,
//                 year: value.getFullYear(),
//             };
//         }
//         return { day: "", month: "", year: "" };
//     });

//     const [error, setError] = useState(false);

//     const days = Array.from({ length: 31 }, (_, i) => i + 1);
//     const months = Array.from({ length: 12 }, (_, i) => i + 1);
//     const startYear = new Date().getFullYear() - 1; // Start from one year before the current year
//     const years = Array.from({ length: 99 }, (_, i) => startYear - i);

//     const handleDateChange = (field, value) => {
//         const updatedDate = { ...selectedDate, [field]: value ? parseInt(value, 10) : "" };
//         setSelectedDate(updatedDate);

//         const isValid = updatedDate.day && updatedDate.month && updatedDate.year;

//         if (isValid) {
//             setError(false);
//             // const formattedDate = new Date(updatedDate.year, updatedDate.month - 1, updatedDate.day)
//             const formattedDateString = `${updatedDate.day}-${updatedDate.month}-${updatedDate.year}`;
//             console.log("formattedDate", formattedDateString);

//             onChange && onChange(formattedDateString); // Pass a valid Date object
//         } else {
//             setError(true);
//             onChange && onChange(null); // Pass null if invalid
//         }
//     };

//     return (
//         <Box
//             sx={{
//                 display: "flex",
//                 flexDirection: "column",
//                 gap: 2,
//                 width: "80%",
//                 "@media (max-width:320px)": {
//                     gap: 1, // Reduce gap for small screens
//                 },
//             }}
//         >
//             <Box
//                 sx={{
//                     display: "flex",
//                     gap: 1,
//                     "@media (max-width:320px)": {
//                         flexDirection: "column", // Stack dropdowns on small screens
//                     },
//                 }}
//             >
//                 {/* Day Dropdown */}
//                 <TextField
//                     select
//                     label="Day"
//                     value={selectedDate.day}
//                     onChange={(e) => handleDateChange("day", e.target.value)}
//                     required={required}
//                     fullWidth
//                     sx={{
//                         width: "200px",
//                         minWidth: "70px",
//                         "@media (max-width:320px)": {
//                             minWidth: "auto",
//                         },
//                     }}
//                     size="small"
//                     error={error && !selectedDate.day}
//                 >
//                     <MenuItem value="">Select Day</MenuItem>
//                     {days.map((day) => (
//                         <MenuItem
//                             key={day}
//                             value={day}
//                             sx={{
//                                 fontSize: "0.9rem",
//                                 "@media (max-width:320px)": { fontSize: "0.7rem" }, // Smaller font for mobile
//                             }}
//                         >
//                             {day}
//                         </MenuItem>
//                     ))}
//                 </TextField>

//                 {/* Month Dropdown */}
//                 <TextField
//                     select
//                     label="Month"
//                     value={selectedDate.month}
//                     onChange={(e) => handleDateChange("month", e.target.value)}
//                     required={required}
//                     fullWidth
//                     sx={{
//                         width: "200px",
//                         minWidth: "70px",
//                         "@media (max-width:320px)": {
//                             minWidth: "auto",
//                         },
//                     }}
//                     size="small"
//                     error={error && !selectedDate.month}
//                 >
//                     <MenuItem aria-invalid value="">Select Month</MenuItem>
//                     {months.map((month) => (
//                         <MenuItem
//                             key={month}
//                             value={month}
//                             sx={{
//                                 fontSize: "0.9rem",
//                                 "@media (max-width:320px)": { fontSize: "0.7rem" }, // Smaller font for mobile
//                             }}
//                         >
//                             {month}
//                         </MenuItem>
//                     ))}
//                 </TextField>

//                 {/* Year Dropdown */}
//                 <TextField
//                     select
//                     label="Year"
//                     value={selectedDate.year}
//                     onChange={(e) => handleDateChange("year", e.target.value)}
//                     required={required}
//                     fullWidth
//                     sx={{
//                         width: "200px",

//                         minWidth: "80px",
//                         "@media (max-width:320px)": {
//                             minWidth: "auto",
//                         },
//                     }}
//                     size="small"
//                     error={error && !selectedDate.year}
//                 >
//                     <MenuItem value="">Select Year</MenuItem>
//                     {years.map((year) => (
//                         <MenuItem
//                             key={year}
//                             value={year}
//                             sx={{
//                                 fontSize: "0.9rem",
//                                 "@media (max-width:320px)": { fontSize: "0.7rem" }, // Smaller font for mobile
//                             }}
//                         >
//                             {year}
//                         </MenuItem>
//                     ))}
//                 </TextField>
//             </Box>

//             {/* Error Message */}
//             {error && (
//                 <FormHelperText
//                     error
//                     sx={{
//                         fontSize: "0.8rem",
//                         "@media (max-width:320px)": { fontSize: "0.7rem" },
//                     }}
//                 >
//                     Please select a valid day, month, and year.
//                 </FormHelperText>
//             )}
//         </Box>
//     );
// };

// export default SimpleDatePicker;

import React, { useEffect, useState } from "react";
import { TextField, MenuItem, Box, FormHelperText } from "@mui/material";
import moment from "moment";

const SimpleDatePicker = ({ value, onChange, required }) => {
  const [selectedDate, setSelectedDate] = useState({
    day: "",
    month: "",
    year: "",
  });
  const [error, setError] = useState(false);

  /* ---------------- SYNC FROM PARENT (EDIT MODE FIX) ---------------- */
  useEffect(() => {
    if (!value) {
      setSelectedDate({ day: "", month: "", year: "" });
      return;
    }

    const m = moment.isMoment(value)
      ? value
      : moment(value, ["YYYY-MM-DD", "D-MM-YYYY", "DD-MM-YYYY"], true);

    if (m.isValid()) {
      setSelectedDate({
        day: m.date(),
        month: m.month() + 1,
        year: m.year(),
      });
      setError(false);
    }
  }, [value]);

  /* ---------------- OPTIONS ---------------- */
  const days = Array.from({ length: 31 }, (_, i) => i + 1);
  const months = Array.from({ length: 12 }, (_, i) => i + 1);
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 100 }, (_, i) => currentYear - i);

  /* ---------------- CHANGE HANDLER ---------------- */
  const handleChange = (field, val) => {
    const updated = { ...selectedDate, [field]: val ? Number(val) : "" };
    setSelectedDate(updated);

    const { day, month, year } = updated;

    if (day && month && year) {
      const m = moment({ year, month: month - 1, day });
      if (m.isValid()) {
        setError(false);
        onChange && onChange(m); // ✅ RETURN MOMENT
        return;
      }
    }

    setError(true);
    onChange && onChange(null);
  };

  /* ---------------- UI ---------------- */
  return (
   <Box sx={{ display: "flex", flexDirection: "column", gap: 1, width: "100%" }}>
  <Box sx={{ display: "flex", gap: 1 }}>
    <TextField
      select
      label="Day"
      value={selectedDate.day}
      onChange={(e) => handleChange("day", e.target.value)}
      required={required}
      size="small"
      fullWidth
      error={error && !selectedDate.day}
      sx={{
        "& .MuiSelect-select": {
          whiteSpace: "normal",
          textOverflow: "unset",
        }
      }}
    >
      <MenuItem value="">Day</MenuItem>
      {days.map((d) => (
        <MenuItem key={d} value={d}>
          {d}
        </MenuItem>
      ))}
    </TextField>

    <TextField
      select
      label="Month"
      value={selectedDate.month}
      onChange={(e) => handleChange("month", e.target.value)}
      required={required}
      size="small"
      fullWidth
      error={error && !selectedDate.month}
      sx={{
        "& .MuiSelect-select": {
          whiteSpace: "normal",
          textOverflow: "unset",
        }
      }}
    >
      <MenuItem value="">Month</MenuItem>
      {months.map((m) => (
        <MenuItem key={m} value={m}>
          {m}
        </MenuItem>
      ))}
    </TextField>

    <TextField
      select
      label="Year"
      value={selectedDate.year}
      onChange={(e) => handleChange("year", e.target.value)}
      required={required}
      size="small"
      fullWidth
      error={error && !selectedDate.year}
      sx={{
        "& .MuiSelect-select": {
          whiteSpace: "normal",
          textOverflow: "unset",
        }
      }}
    >
      <MenuItem value="">Year</MenuItem>
      {years.map((y) => (
        <MenuItem key={y} value={y}>
          {y}
        </MenuItem>
      ))}
    </TextField>
  </Box>

  {error && (
    <FormHelperText error>Please select a valid date</FormHelperText>
  )}
</Box>

  );
};

export default SimpleDatePicker;
